import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoSlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 130 39'
    {...props}
  >
    <path
      fill='currentColor'
      d='m42.347 27.87 1.468-3.432c1.608 1.19 3.704 1.82 5.802 1.82 1.537 0 2.516-.594 2.516-1.504-.035-2.522-9.262-.56-9.332-6.9-.035-3.22 2.831-5.707 6.886-5.707 2.41 0 4.823.595 6.535 1.961l-1.372 3.505c-1.575-1.013-3.521-1.72-5.373-1.72-1.258 0-2.097.596-2.097 1.367.035 2.486 9.332 1.12 9.436 7.178 0 3.292-2.796 5.603-6.78 5.603-2.936 0-5.627-.7-7.69-2.171zm58.458-4.674a4.26 4.26 0 0 1-3.711 2.17 4.27 4.27 0 0 1-4.264-4.272 4.27 4.27 0 0 1 4.264-4.272 4.26 4.26 0 0 1 3.711 2.17l4.082-2.265a8.92 8.92 0 0 0-7.793-4.58c-4.932 0-8.93 4.005-8.93 8.947s3.998 8.947 8.93 8.947a8.92 8.92 0 0 0 7.793-4.58zm-41.34 6.495h5.102V4.699h-5.102zm47.999-24.992v24.992h5.102v-7.488l6.047 7.488h6.522l-7.689-8.895 7.129-8.3h-6.242l-5.767 6.9V4.7zm-27.176 7.798v2.031c-.839-1.4-2.901-2.38-5.068-2.38-4.473 0-8.003 3.956-8.003 8.929 0 4.972 3.53 8.964 8.003 8.964 2.167 0 4.23-.98 5.068-2.381v2.03h5.102V12.498zm0 10.733c-.734 1.226-2.272 2.136-3.984 2.136a4.267 4.267 0 0 1-4.264-4.272 4.27 4.27 0 0 1 4.264-4.272c1.712 0 3.25.945 3.984 2.206z'
    />
    <path
      fill='#36C5F0'
      d='M15.4 4.147a2.997 2.997 0 0 0-2.767 4.147 3 3 0 0 0 2.767 1.853h2.995v-3a2.997 2.997 0 0 0-2.995-3m0 8H7.416a2.997 2.997 0 0 0-2.994 3c0 1.657 1.34 3 2.994 3h7.985a2.997 2.997 0 0 0 2.994-3c0-1.656-1.341-3-2.995-3'
    />
    <path
      fill='#2EB67D'
      d='M34.363 15.148c0-1.657-1.34-3-2.994-3a2.997 2.997 0 0 0-2.994 3v3h2.994a2.997 2.997 0 0 0 2.994-3m-7.984 0v-8a2.997 2.997 0 0 0-2.994-3 2.997 2.997 0 0 0-2.994 3v8c0 1.657 1.34 3 2.994 3a3 3 0 0 0 2.994-3'
    />
    <path
      fill='#ECB22E'
      d='M23.385 34.148a3 3 0 0 0 2.994-3 3 3 0 0 0-2.994-3H20.39v3c0 1.656 1.34 3 2.994 3m0-8h7.984a2.997 2.997 0 0 0 2.994-3 2.997 2.997 0 0 0-2.994-3h-7.984a2.997 2.997 0 0 0-2.767 4.146 3 3 0 0 0 2.767 1.853'
    />
    <path
      fill='#E01E5A'
      d='M4.422 23.147a2.997 2.997 0 0 0 2.994 3 2.997 2.997 0 0 0 2.994-3v-3H7.416a2.997 2.997 0 0 0-2.994 3m7.984 0v8c0 1.657 1.34 3 2.994 3a3 3 0 0 0 2.995-3v-8a2.997 2.997 0 0 0-2.995-3 2.997 2.997 0 0 0-2.994 3'
    />
  </svg>
);
export default SvgLogoSlack;
